// SUMMARY: Evuno brand mark — inline SVG that inherits the current text color so it adapts to theme and context

interface LogoProps {
	className?: string
}

export function Logo({ className }: LogoProps) {
	return (
		<svg
			viewBox="0 0 993.36 990.35"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Evuno"
			className={className}
		>
			<path d="M480.96,850.12c-81.19,0-156.02-26.83-216.07-72-86.18-64.78-141.81-167.4-141.81-282.92s55.63-218.18,141.81-282.96c60.06-45.18,134.89-72,216.07-72h366.35C757.38,53.46,634.61,0,499.25,0,223.52,0,0,221.7,0,495.17s223.52,495.17,499.25,495.17c135.37,0,258.13-53.46,348.06-140.23h-366.35Z" />
			<path d="M479.6,708.16h470.46c21.23-44.12,36.05-91.85,43.31-142H277.11c29.46,82.74,108.98,142,202.48,142Z" />
			<path d="M479.6,282.19c-93.5,0-173.03,59.26-202.48,142h716.25c-7.26-50.15-22.08-97.88-43.31-142h-470.46Z" />
		</svg>
	)
}
